import Vue from 'vue';
import StoreLocator from './StoreLocator.vue';

Vue.config.productionTip = false
let vueEl;

initStoreLocatorComponent();

function initStoreLocatorComponent() {
  vueEl = new Vue({
    el: '#store-locator',
    components: {
      StoreLocator
    }
  });
}

window.updateStoreLocatorComponent = initStoreLocatorComponent;